import { useContext } from 'react';
import { AuthContext } from '@/auth/AuthContext';
import useAuthStore from '@/store/authStore';

export function useAuth() {
  const context = useContext(AuthContext);
  if (context) {
    return context;
  }

  // Non-hook fallback using Zustand getState API
  const state = useAuthStore.getState();
  return {
    user: state.user,
    token: state.token,
    isAuthenticated: state.isAuthenticated,
    isInitialized: true,
    loading: false,
    login: state.login,
    logout: state.logout,
    role: state.user?.role || null,
  };
}
